import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import '@/styles/element-theme.scss'
import '@/styles/index.scss'

import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
Vue.use(VueVideoPlayer)
import ECharts from 'echarts'
import BaseContainer from '@/components/BaseContainer'
import Pagination from '@/components/Pagination'
// 图片预览组件
import ImagePreview from "@/components/ImagePreview"
Vue.component('Pagination', Pagination)
Vue.component('ImagePreview', ImagePreview)
Vue.prototype.$echarts = ECharts
import VueEcharts from 'vue-echarts'
import '@/styles/index.scss' // global css
import request from '@/utils/request'
window.axios = request
// https://avuejs.com/doc/installation
import Avue from '@smallwei/avue'
import '@smallwei/avue/lib/index.css'
Vue.use(Avue)
window.$imgUrl ='http://mrhsapp-1303828840.cos.ap-shanghai.myqcloud.com'

import App from './App'
import store from './store'
import router from './router/index'
import * as filters from './filters'
import '@/icons' // icon
import '@/permission' // permission control

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

// set ElementUI lang to EN
Vue.use(ElementUI)
// 如果想要中文版 element-ui，按如下方式声明
// Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.component('v-chart', VueEcharts)
Vue.component('base-container', BaseContainer)

// 挂载全局过滤器
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
